module.exports = __webpack_public_path__ + "media/application/images/cluster-20c402f96eadf0fb81adbdfcc06add5a.svg";